import { useTranslation } from "react-i18next";

import { CircleArrowRightIcon } from "lucide-react";

import { ImageWithFallback } from "simplydo/react/components/ImageWithFallback";
import {
  Card,
  CardAction,
  CardContent,
  CardImage,
} from "simplydo/react/ui/card";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Popup } from "simplydo/react/ui/popup";

import util from "utils/utils";

import { UserChip } from "components/lib/Chips";

import type { SuggestedIdeaCardProps } from "./types";

const SuggestedIdeaCard = ({
  onHeaderClicked,
  idea,
}: SuggestedIdeaCardProps) => {
  const { t } = useTranslation();

  return (
    <Card
      fluid
      elevation="large"
      onClick={() => onHeaderClicked()}
      style={{ height: "100%" }}
    >
      <CardImage dimmed>
        <ImageWithFallback
          src={util.ideaCoverImage(idea, "640x100")}
          fallbackSrc={util.ideaCoverImage(idea)}
        />
      </CardImage>
      <CardContent>
        <H3 style={{ color: "#4d4949" }}>{idea.name}</H3>
        {idea.ownerChallenge && (
          <div style={{ marginBottom: 5, textDecorationLine: "underline" }}>
            {idea.ownerChallenge.name}
          </div>
        )}

        {idea.owner ? (
          <span
            style={{
              display: "flex",
              color: "gray",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
          >
            <UserChip user={idea.owner} compact="very" />
          </span>
        ) : null}

        {idea.summarisedContent ? (
          <Popup
            on="hover"
            trigger={
              <p
                style={{
                  marginTop: 8,
                  fontSize: 13,
                  color: "grey",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {idea.summarisedContent}
              </p>
            }
          >
            {idea.summarisedContent}
          </Popup>
        ) : null}
      </CardContent>
      <CardAction color="primary" onClick={() => onHeaderClicked()}>
        {t("ideas.card.view")} <Icon icon={CircleArrowRightIcon} />
      </CardAction>
    </Card>
  );
};

export default SuggestedIdeaCard;
